/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-lone-blocks */
import React, { useState, useEffect } from "react";
import "../theme/Reclasificacion.css";
import { registerLocale } from "react-datepicker";
import es from "date-fns/locale/es";
import moment from "moment";
import "react-datepicker/dist/react-datepicker.css";

// IMPORTANTE: Asegúrate de tener estas imágenes o usa los SVGs definidos abajo si prefieres
import imgCierre from "../assets/icon-lote-pin-pad.svg";
import imgDeposito from "../assets/icon-dispositivos-efectivo.svg";
import imgEntrega from "../assets/icon-entrega-valores.svg";
import iconoCofreElectronico from "../assets/icon-cofre-electronico.svg";
import iconoReporteVentas from "../assets/icon-reporte-ventas.svg";

import iconEfectivo from "../assets/icon-efectivo.svg";
import iconDepositosEfectivo from "../assets/icon-dispositivos-efectivo.svg";


import { TextCierredeDiaFormSeparador } from "./TextCierredeDiaFormSeparador";
import { Modal, Image } from "antd";
import { fetchUploadUrl } from "../Api/fetchUploadUrl";
import { LoadingSpinner } from "./LoadingSpinner";
import { UseAdmin, UseUser, UseAuth } from "../hooks";
import { fetchReclasificacionCatalogoDias } from "../Api/fetchReclasificacionCatalogoDias";
import { fetchBitacora } from "../Api/fetchBitacora";
import Switch from "react-switch";
import axios from "axios";
import { fetchReclasificacionAdd } from "../Api/fetchReclasificacionAdd";
import { NumericFormat } from "react-number-format";
import { VERSION_APP } from "../utilities";
import compressImage from "../utils/CompressImage";
import { ModalCofreElectronico } from "./Modals/CierreDia/ModalCofreElectronico";
import { ModalReporteVentas } from "./Modals/CierreDia/ModalReporteVentas";
import iconTarjetas from "../assets/icon-tarjetas.svg";
import iconAgregaores from "../assets/icon-agregadores.svg";
import iconValesFisicos from "../assets/icon-vales-fisicos.svg";
import iconOtros from "../assets/icon-otros.svg";
import iconFichaDeposito from "../assets/icon-ficha-deposito.svg";

registerLocale("es", es);

export const IMAGE_UPLOAD_TYPE = {
    COFRE_ELECTRONICO: "Ficha_Cofre_Electronico",
    REPORTE_VENTAS: "Ficha_Reporte_Ventas",
};

export const ReclasificacionIngresosForm = (props) => {
    const { formasPago, fecha } = props;
    const [errors, setErrors] = useState({});
    const { brandfiMarcaId, branchFiSucursalId, branchFiPaisId, branchFcNombre } = UseAdmin();
    const { employeeId, mail, device } = UseUser();
    const { uniqueId } = UseAuth();
    const [deviceInfo, setDeviceInfo] = useState(null);
    const [locationLatitude, setLocationLatitude] = useState(null);
    const [locationLongitude, setLocationLongitude] = useState(null);
    const [isDiaRecolecion, setIsDiaRecolecion] = useState();

    //Datos para imagenes
    const [isShowImage, setIsShowImage] = useState(false);
    const [isShowImageDep, setIsShowImageDep] = useState(false);
    const [isShowImageVal, setIsShowImageVal] = useState(false);
    const [isShowImageCofreElectronico, setIsShowImageCofreElectronico] = useState(false);
    const [isShowImageReporteVentas, setIsShowImageReporteVentas] = useState(false);
    const [modalVisibleFicha, setModalVisibleFicha] = useState(false);
    const [modalVisibleValores, setModalVisibleValores] = useState(false);
    const [modalVisibleCofreElectronico, setModalVisibleCofreElectronico] = useState(false);
    const [modalVisibleReporteVentas, setModalVisibleReporteVentas] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [imageURL, setImageURL] = useState(null);
    const [imageDepositoURL, setImageDepositoURL] = useState(null);
    const [imageValoresURL, setImageValoresURL] = useState(null);
    const [imageCofreElectronicoURL, setImageCofreElectronicoURL] = useState(null);
    const [imageReporteVentasURL, setImageReporteVentasURL] = useState(null);
    const [image, setImage] = useState(null);
    const [imageValores, setImageValores] = useState(null);
    const [imageCofreElectronico, setImageCofreElectronico] = useState(null);
    const [imageReporteVentas, setImageReporteVentas] = useState(null);
    const [imageDeposito, setImageDeposito] = useState(null);
    const [checked, setChecked] = useState(false);
    const [suma, setSuma] = useState();
    const [efectivoDepositar, setEfectivoDepositar] = useState();
    const [propina, setPropina] = useState(null);
    const [nombre, setNombre] = useState(null);
    const [formDataLoaded, setFormDataLoaded] = useState(false);
    const [datosEnviados, setDatosEnviados] = useState(false);
    const [comentario, setComentario] = useState("");
    const [noTicket, setnoTicket] = useState(null);
    const [AllNull, setAllNull] = useState(false);
    const [shouldShowCofreElectronico, setShouldShowCofreElectronico] = useState(false);

    const [formData, setFormData] = useState({
        amex: null,
        tpv: null,
        pinpad: null,
        vales: null,
        valescdmx: null,
        delivery: null,
        didi: null,
        didicredito: null,
        rappi: null,
        rapicargo: null,
        uber: null,
        uberdirect: null,
        mercadopago: null,
        wow: null,
        mop: null,
        startbuckRegords: null,
        scanpay: null,
        bkapp: null,
        eventosWalmart: null,
        eventosEmpresariales: null,
        efectivomxp: null,
        efectivousd: null,
        didiEfectivo: null,
        uberEfectivo: null,
        rappiEfectivo: null,
        anticipoOtrosCreditos: null,
        otrosCreditos: null,
        deliverySr: null,
    });

    const [formDataNoSuma, setformDataNoSuma] = useState({
        VTotal: 0,
        depostitoTombola: null,
        propinpor: null,
    });

    const handleChangeNoSuma = (values, nombreCampo) => {
        setformDataNoSuma({
            ...formDataNoSuma,
            [nombreCampo]: values.floatValue,
        });
    };

    const handleValueChange = (values, nombreCampo) => {
        setFormData({
            ...formData,
            [nombreCampo]: values.floatValue,
        });
    };

    const handleChangeComentario = (event) => {
        const inputValue = event.target.value;
        setComentario(inputValue.slice(0, 300));
    };

    const handleChangeTicket = (event) => {
        const inputValue = event.target.value;
        setnoTicket(inputValue.slice(0, 12));
    };

    useEffect(() => {
        const todosNull = Object.values(formData).every((value) => value === null);
        setAllNull(todosNull);
    }, [formData]);

    useEffect(() => {
        const total = Object.values(formData).reduce((acumulador, valor) => {
            const numeroValor = parseFloat(valor);
            if (!isNaN(numeroValor)) {
                return acumulador + numeroValor;
            } else {
                return acumulador;
            }
        }, 0);
        setSuma(total);
    }, [formData]);

    useEffect(() => {
        setPropina((Number(formDataNoSuma.propinpor) * Number(suma)) / 100);
    }, [suma, formDataNoSuma.propinpor]);

    useEffect(() => {
        setEfectivoDepositar(
            Number(formData.efectivomxp) +
            Number(formData.efectivousd) -
            Number(formDataNoSuma.depostitoTombola)
        );
    }, [formData.efectivomxp, formDataNoSuma.depostitoTombola, formData.efectivousd]);

    const handleChangCheck = (checked) => {
        setChecked(checked);
    };

    const handleChangeNombre = (event) => {
        setNombre(event.target.value);
    };

    const date = new Date();
    let hour = date.getHours();
    let minute = date.getMinutes();
    let segundos = date.getSeconds();
    hour = hour < 10 ? `0${hour}` : hour;
    minute = minute < 10 ? `0${minute}` : minute;
    segundos = segundos < 10 ? `0${segundos}` : segundos;

    const hoyfecha = `${fecha} ${hour}:${minute}:${segundos}`;

    useEffect(() => {
        const loadFormData = async () => {
            try {
                const saveDataLocal = `formData-${fecha}`;
                const savedFormData = localStorage.getItem(saveDataLocal);

                if (savedFormData) {
                    const parsedFormData = JSON.parse(savedFormData);
                    setFormData(parsedFormData.formData);
                    setImageURL(parsedFormData.imageURL);
                    setImage(parsedFormData.imageURL);
                    setImageDepositoURL(parsedFormData.imageDepositoURL);
                    setImageDeposito(parsedFormData.imageDepositoURL);
                    setImageValoresURL(parsedFormData.imageValoresURL);
                    setImageValores(parsedFormData.imageValoresURL);
                    setImageCofreElectronicoURL(parsedFormData.imageCofreElectronicoURL);
                    setImageCofreElectronico(parsedFormData.imageCofreElectronicoURL);
                    setImageReporteVentasURL(parsedFormData.imageReporteVentasURL);
                    setImageReporteVentas(parsedFormData.imageReporteVentasURL);
                    setNombre(parsedFormData.nombre);
                    setComentario(parsedFormData.comentario);
                    setformDataNoSuma(parsedFormData.formDataNoSuma);
                    alert("Datos de cierre de día pendientes por enviar");
                }
            } catch (error) {
            } finally {
                setFormDataLoaded(true);
            }
        };

        if (!formDataLoaded && !datosEnviados) {
            loadFormData();
        }
    }, [formDataLoaded, datosEnviados]);

    useEffect(() => {
        if (formDataLoaded && !datosEnviados) {
            if (
                Object.values(formData).some((value) => value !== null) ||
                imageDepositoURL !== null ||
                imageValoresURL !== null ||
                imageURL !== null ||
                imageCofreElectronicoURL !== null ||
                imageReporteVentasURL !== null ||
                nombre !== null ||
                comentario !== "" ||
                Object.values(formDataNoSuma).some((value) => value !== null)
            ) {
                saveDataLocally();
            }
        }
    }, [
        formData,
        formDataNoSuma,
        imageDepositoURL,
        imageValoresURL,
        imageCofreElectronicoURL,
        imageReporteVentasURL,
        imageURL,
        nombre,
        comentario,
        formDataLoaded,
        datosEnviados,
    ]);

    const saveDataLocally = async () => {
        try {
            const totalData = {
                formData,
                formDataNoSuma,
                imageURL,
                imageDepositoURL,
                imageValoresURL,
                imageCofreElectronicoURL,
                imageReporteVentasURL,
                nombre,
                comentario,
                fecha: hoyfecha,
            };
            const saveDataLocal = `formData-${fecha}`;
            localStorage.setItem(saveDataLocal, JSON.stringify(totalData));
            console.log(`Datos guardados correctamente en ${saveDataLocal}`);
        } catch (error) {
        }
    };

    useEffect(() => {
        getCatalogoRecolecion();
    }, [fecha]);

    const getCatalogoRecolecion = () => {
        if (branchFiPaisId !== null && brandfiMarcaId !== null && branchFiSucursalId !== null) {
            const onFailure = (error) => {
            };
            const onSuccess = ({ data }) => {
                const filteredRecords = data.records.filter((record) => record.estatus === 1);
                const numerosDiaRecoleccion = filteredRecords.map((record) => record.diaRecoleccion);
                const dateParts = fecha.split("/");
                const year = parseInt(dateParts[2], 10);
                const month = parseInt(dateParts[1], 10) - 1;
                const day = parseInt(dateParts[0], 10);
                const date = new Date(year, month, day);
                const dayOfWeek = date.getDay();
                const encontrado = numerosDiaRecoleccion.some((item) => item === dayOfWeek);
                setIsDiaRecolecion(encontrado);
                const recoleccionObj = filteredRecords.filter(
                    (record) => record.diaRecoleccion === dayOfWeek
                )[0];
                setShouldShowCofreElectronico(recoleccionObj.cofre === 1);
            };

            fetchReclasificacionCatalogoDias(
                Number(branchFiPaisId),
                Number(brandfiMarcaId),
                branchFiSucursalId
            )
                .then(onSuccess)
                .catch(onFailure);
        }
    };

    useEffect(() => {
        const getPublicIP = async () => {
            try {
                const response = await axios.get("https://api.ipify.org?format=json");
                setDeviceInfo(`Ip publica ${response.data.ip}`);
            } catch (error) {
            }
        };
        getPublicIP();
    }, [fecha]);

    useEffect(() => {
        const getLocation = () => {
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(
                    (position) => {
                        setLocationLatitude(position.coords.latitude);
                        setLocationLongitude(position.coords.longitude);
                    },

                    (error) => alert("Error al obtener la ubicación:", error)
                );
            } else {
                alert("Geolocalización no es soportada por este navegador.");
            }
        };
        getLocation();
    }, []);

    const handleImageChange = (event, setImageCallback) => {
        const file = event.target.files[0];
        if (file) {
            compressImage(file).then((compressed) => {
                if (compressed) {
                    setImageCallback(compressed);
                }
            });
        }
    };

    const handleImageChangeFicha = (event) => {
        handleImageChange(event, setImage);
    };

    const handleImageChangeDeposito = (event) => {
        handleImageChange(event, setImageDeposito);
    };

    const handleImageChangeCofreElectronico = (event) => {
        handleImageChange(event, setImageCofreElectronico);
    };

    const handleImageChangeReporteVentas = (event) => {
        handleImageChange(event, setImageReporteVentas);
    };

    const handleImageChangeValores = (event) => {
        handleImageChange(event, setImageValores);
    };

    const uploadImage = (
        type,
        imageFun,
        setImageURLFuntion,
        setIsShowImageFuntion,
        setModalVisibleFuntion
    ) => {
        setIsShowImageFuntion(true);
        const onFailure = ({ error, config }) => {
            getBitacora(config, "Subir imagen", error);
            alert(error);
            setIsShowImageFuntion(false);
        };
        const onSuccess = ({ data, config }) => {
            getBitacora(config, "Subir imagen", data);
            setImageURLFuntion(data[type]);
            setModalVisibleFuntion(false);
            setIsShowImageFuntion(false);
        };
        fetchUploadUrl(
            branchFiSucursalId,
            branchFcNombre,
            hoyfecha,
            type,
            imageFun
        )
            .then(onSuccess)
            .catch(onFailure);
    };

    const saveImage = () => {
        uploadImage("Cierre_Lote", image, setImageURL, setIsShowImage, setModalVisible);
    };

    const saveImageDeposito = () => {
        uploadImage(
            "Ficha_Deposito",
            imageDeposito,
            setImageDepositoURL,
            setIsShowImageDep,
            setModalVisibleFicha
        );
    };

    const saveImageCofreElectronico = () => {
        uploadImage(
            IMAGE_UPLOAD_TYPE.COFRE_ELECTRONICO,
            imageCofreElectronico,
            setImageCofreElectronicoURL,
            setIsShowImageCofreElectronico,
            setModalVisibleCofreElectronico
        );
    };

    const saveImageReporteVentas = () => {
        uploadImage(
            IMAGE_UPLOAD_TYPE.REPORTE_VENTAS,
            imageReporteVentas,
            setImageReporteVentasURL,
            setIsShowImageReporteVentas,
            setModalVisibleReporteVentas
        );
    };

    const saveImageValores = () => {
        uploadImage(
            "Ficha_Entrega_Valores",
            imageValores,
            setImageValoresURL,
            setIsShowImageVal,
            setModalVisibleValores
        );
    };

    const getBitacora = async (requestStore, description, responseData) => {
        const deviceWeb = `${uniqueId}-${device}`;
        const key = `${uniqueId}-${device}-${employeeId}`;
        const obtenerFechaEnFormato = () => {
            const ahora = moment();
            const fechaEnFormato = ahora.format("YY/MM/DD HH:mm:ss.SSS");
            return fechaEnFormato;
        };
        const fechaActualEnFormato = obtenerFechaEnFormato();

        if (brandfiMarcaId != null && requestStore != null && responseData != null) {
            const onFailure = (error) => {
            };

            const onSuccess = ({ data }) => {
            };

            fetchBitacora(
                mail,
                deviceWeb,
                fechaActualEnFormato,
                key,
                requestStore,
                responseData,
                description,
                VERSION_APP,
                employeeId,
                brandfiMarcaId,
                branchFiSucursalId,
                branchFiPaisId
            )
                .then(onSuccess)
                .catch(onFailure);
        }
    };

    const setSaveReclasificacion = () => {
        if (!isDiaRecolecion) {
            setFormToFetch();
        } else {
            setFormToFetch();
        }

        function setFormToFetch() {
            const errors = {};
            if (formasPago.some((item) => item === 1) && formData.amex == null) errors.amex = "Ingresa el valor de Amex";
            if (formasPago.some((item) => item === 2) && formData.tpv == null) errors.tpv = "Ingresa el valor de TPV";
            if (formasPago.some((item) => item === 3) && formData.pinpad == null) errors.pinpad = "Ingresa el valor de PinPad";
            if (formasPago.some((item) => item === 4) && formData.vales == null) errors.vales = "Ingresa el valor de Vales";
            if (formasPago.some((item) => item === 5) && formData.valescdmx == null) errors.valescdmx = "Ingresa el valor de Vales CDMX";
            if (formasPago.some((item) => item === 6) && formData.delivery == null) errors.delivery = "Ingresa el valor de Delivery Alsea";
            if (formasPago.some((item) => item === 7) && formData.didi == null) errors.didi = "Ingresa el valor de Didi";
            if (formasPago.some((item) => item === 8) && formData.didicredito == null) errors.didicredito = "Ingresa el valor de Didi Creditos";
            if (formasPago.some((item) => item === 9) && formData.rappi == null) errors.rappi = "Ingresa el valor de Rappi";
            if (formasPago.some((item) => item === 10) && formData.rapicargo == null) errors.rapicargo = "Ingresa el valor de Rappi Cargo";
            if (formasPago.some((item) => item === 11) && formData.uber == null) errors.uber = "Ingresa el valor de Uber";
            if (formasPago.some((item) => item === 12) && formData.uberdirect == null) errors.uberdirect = "Ingresa el valor de Uber Direct";
            if (formasPago.some((item) => item === 13) && formData.mercadopago == null) errors.mercadopago = "Ingresa el valor de  Mercado Pago";
            if (formasPago.some((item) => item === 14) && formData.wow == null) errors.wow = "Ingresa el valor de WOW";
            if (formasPago.some((item) => item === 15) && formData.mop == null) errors.mop = "Ingresa el valor de MOP";
            if (formasPago.some((item) => item === 16) && formData.startbuckRegords == null) errors.startbuckRegords = "Ingresa el valor de StarBucks Rewards";
            if (formasPago.some((item) => item === 17) && formData.scanpay == null) errors.scanpay = "Ingresa el valor de  Scan & Pay";
            if (formasPago.some((item) => item === 18) && formData.bkapp == null) errors.bkapp = "Ingresa el valor de  BK App";
            if (formasPago.some((item) => item === 19) && formData.eventosWalmart == null) errors.eventosWalmart = "Ingresa el valor de Eventos Walmart";
            if (formasPago.some((item) => item === 20) && formData.eventosEmpresariales == null) errors.eventosEmpresariales = "Ingresa el valor de Eventos Empresariales";
            if (formasPago.some((item) => item === 21) && formData.efectivomxp == null) errors.efectivomxp = "Ingresa el valor de Efectivo MXP";
            if (formasPago.some((item) => item === 22) && formData.efectivousd == null) errors.efectivousd = "Ingresa el valor de Efectivo USD";
            if (formasPago.some((item) => item === 23) && formDataNoSuma.propinpor == null) errors.propinpor = "Ingresa el porcentaje de propina";
            if (formasPago.some((item) => item === 24) && formData.didiEfectivo == null) errors.didiEfectivo = "Ingresa el valor de Didi Efectivo";
            if (formasPago.some((item) => item === 25) && formData.uberEfectivo == null) errors.uberEfectivo = "Ingresa el valor de Uber Efectivo";
            if (formasPago.some((item) => item === 26) && formData.rappiEfectivo == null) errors.rappiEfectivo = "Ingresa el valor de Rappi Efectivo";
            if (formasPago.some((item) => item === 27) && formData.anticipoOtrosCreditos == null) errors.anticipoOtrosCreditos = "Ingresa el valor de Anticipo y otros creditos";
            if (formasPago.some((item) => item === 28) && formData.otrosCreditos == null) errors.otrosCreditos = "Ingresa el valor Otros creditos";
            if (formasPago.some((item) => item === 29) && formData.deliverySr == null) errors.deliverySr = "Ingresa el valor de Delivery SR";
            if (formDataNoSuma.VTotal == null) errors.VTotal = "Ingresa el valor de Venta total";
            if (nombre == null) errors.nombre = "Ingresa en nombre el gerente en turno";
            if (imageURL == null) {
                alert("Ingresa evidencia de cierre de lote");
                return;
            }
            if (formDataNoSuma.depostitoTombola == null) errors.depostitoTombola = "Ingresa el valor de Deposito en tombola";
            if (formData.efectivomxp > 0 && imageDepositoURL == null) {
                alert("Ingresa de ficha depósito es requerida");
                return;
            }
            if (isDiaRecolecion) {
                if (imageValoresURL != null || !isNaN(parseInt(noTicket, 10))) {
                    // OK
                } else {
                    alert("Ingresar una evidencia de entrega a valores o el número de #ticket");
                    return;
                }
            }
            if (shouldShowCofreElectronico && imageCofreElectronicoURL == null) {
                alert("Ingrese imagen de cofre electrónico");
                return;
            }
            if (imageReporteVentasURL == null) {
                alert("Ingrese imagen de reporte de ventas");
                return;
            }

            if (Object.keys(errors).length > 0) {
                setErrors(errors);
                return;
            } else {
                setErrors("");
                validaIguales();
            }

            function validaIguales() {
                const vnTotal = formDataNoSuma.VTotal;
                const nTotal = Number(suma.toFixed(2));
                if (Number(vnTotal) !== nTotal) {
                    alert("Venta Total y Total deben ser iguales");
                } else {
                    allValidateReadytoSet();
                }
            }

            function allValidateReadytoSet() {
                // ... Preparación de variables para el fetch ...
                const valoresImg = imageValoresURL !== null ? imageValoresURL : "Null";
                const cofreElectronicoImg = imageCofreElectronicoURL !== null ? imageCofreElectronicoURL : "Null";
                const reporteVentasImg = imageReporteVentasURL !== null ? imageReporteVentasURL : "Null";
                const ticketno = !noTicket ? "None" : noTicket;
                const depositoImg = imageDepositoURL !== null ? imageDepositoURL : "Null";
                const mop = formData.mop !== null ? formData.mop : 0;
                const startbuckRe = formData.startbuckRegords !== null ? formData.startbuckRegords : 0;
                const scanypay = formData.scanpay !== null ? formData.scanpay : 0;
                const bkapp = formData.bkapp !== null ? formData.bkapp : 0;
                const eventosWalmart = formData.eventosWalmart !== null ? formData.eventosWalmart : 0;
                const eventosEmpresariales = formData.eventosEmpresariales !== null ? formData.eventosEmpresariales : 0;
                const efectivousd = formData.efectivousd !== null ? formData.efectivousd : 0;
                const porpropina = formDataNoSuma.propinpor !== null ? formDataNoSuma.propinpor : 0;
                const propinatotal = propina !== null ? propina : 0;
                const didiEfectivo = formData.didiEfectivo !== null ? formData.didiEfectivo : 0;
                const uberEfectivo = formData.uberEfectivo !== null ? formData.uberEfectivo : 0;
                const rappiEfectivo = formData.rappiEfectivo !== null ? formData.rappiEfectivo : 0;
                const anticioOtros = formData.anticipoOtrosCreditos !== null ? formData.anticipoOtrosCreditos : 0;
                const otrosCreditos = formData.otrosCreditos !== null ? formData.otrosCreditos : 0;
                const deliverySr = formData.deliverySr !== null ? formData.deliverySr : 0;
                const comentText = comentario !== null ? comentario : "None";

                const onFailure = ({ error, config }) => {
                    getBitacora(config, "Nuevo cierre de dia", error);
                    alert("Ocurrio un error", error);
                };
                const onSuccess = async ({ data, config }) => {
                    getBitacora(config, "Nuevo cierre de dia", data);
                    {
                        data.statusCode !== 200
                            ? alert(data.error)
                            : (alert("Envio exitoso"),
                                setDatosEnviados(true),
                                setFormData({
                                    amex: "", tpv: "", pinpad: "", vales: "", valescdmx: "", delivery: "", didi: "", didicredito: "", rappi: "", rapicargo: "", uber: "", uberdirect: "", mercadopago: "", wow: "", mop: "", startbuckRegords: "", scanpay: "", bkapp: "", eventosWalmart: "", eventosEmpresariales: "", efectivomxp: "", efectivousd: "", didiEfectivo: "", uberEfectivo: "", rappiEfectivo: "", anticipoOtrosCreditos: "", otrosCreditos: "", deliverySr: "",
                                }),
                                setformDataNoSuma({ VTotal: "", ticket: "", depostitoTombola: "", propinpor: "" }),
                                setImageDepositoURL(null), setImageCofreElectronicoURL(null), setImageReporteVentasURL(null), setImageValoresURL(null), setImageURL(null), setNombre(""), setComentario(""), setnoTicket(""), setSuma(""));
                    }
                    try {
                        const saveDataLocal = `formData-${fecha}`;
                        localStorage.removeItem(saveDataLocal);
                    } catch (error) {
                        // Error handling
                    }
                };

                fetchReclasificacionAdd(
                    Number(branchFiPaisId), Number(brandfiMarcaId), branchFiSucursalId, branchFcNombre, Number(formDataNoSuma.VTotal), Number(formDataNoSuma.depostitoTombola), Number(efectivoDepositar), nombre, hoyfecha, deviceInfo, Number(propinatotal), Number(porpropina), imageURL, depositoImg, valoresImg, cofreElectronicoImg, reporteVentasImg, ticketno, Number(locationLatitude), Number(locationLongitude), comentText, Number(formData.amex), Number(formData.tpv), Number(formData.pinpad), Number(formData.vales), Number(formData.valescdmx), Number(formData.delivery), Number(formData.didi), Number(formData.didicredito), Number(formData.rappi), Number(formData.rapicargo), Number(formData.uber), Number(formData.uberdirect), Number(formData.mercadopago), Number(formData.wow), Number(mop), Number(startbuckRe), Number(scanypay), Number(bkapp), Number(eventosWalmart), Number(eventosEmpresariales), Number(formData.efectivomxp), Number(efectivousd), Number(didiEfectivo), Number(uberEfectivo), Number(rappiEfectivo), Number(anticioOtros), Number(otrosCreditos), Number(deliverySr)
                )
                    .then(onSuccess).catch(onFailure);
            }
        }
    };

    const setSaveReclasificacionCloseStores = () => {
        if (nombre === null) {
            alert("Ingresa el nombre de gerente en turno");
        } else {
            const onFailure = ({ error, config }) => {
                getBitacora(config, "Cierre de dia Tienda cerrada", error);
                alert("Ocurrio un error", error);
            };
            const onSuccess = async ({ data, config }) => {
                getBitacora(config, "Cierre de dia Tienda cerrada", data);
                {
                    data.statusCode !== 200
                        ? alert(data.error)
                        : (alert("Envio exitoso "), setDatosEnviados(true), setNombre(""));
                }
                try {
                    const saveDataLocal = `formData-${fecha}`;
                    localStorage.removeItem(saveDataLocal);
                } catch (error) { }
            };

            fetchReclasificacionAdd(
                Number(branchFiPaisId), Number(brandfiMarcaId), branchFiSucursalId, branchFcNombre, Number(0), Number(0), Number(0), nombre, hoyfecha, deviceInfo, Number(0), Number(0), "Null", "Null", "Null", "Null", "Null", "Null", Number(locationLatitude), Number(locationLongitude), "None", Number(0), Number(0), Number(0), Number(0), Number(0), Number(0), Number(0), Number(0), Number(0), Number(0), Number(0), Number(0), Number(0), Number(0), Number(0), Number(0), Number(0), Number(0), Number(0), Number(0), Number(0), Number(0), Number(0), Number(0), Number(0), Number(0), Number(0), Number(0)
            )
                .then(onSuccess).catch(onFailure);
        }
    };

    return (
        <div className="">
            {/* --- 1. HEADER --- */}
            <div className="cd-header-row">
                <div className="cd-header-box full-width">
                    <div className="cd-label-header">Venta Total</div>
                    <NumericFormat
                        name="VTotal"
                        value={formDataNoSuma.VTotal}
                        thousandSeparator={true}
                        decimalScale={2}
                        fixedDecimalScale={true}
                        prefix={"$"}
                        onValueChange={(values) => handleChangeNoSuma(values, "VTotal")}
                        className={`cd-input-header ${errors.VTotal ? "cd-input-error" : ""}`}
                        required
                    />
                    {errors && <div className="cd-error-msg" style={{ color: '#ff8a80' }}>{errors.VTotal}</div>}
                </div>
            </div>

            <div className="cd-section-title">Formas de pago</div>

            {/* --- 2. GRID PRINCIPAL --- */}
            <div className="cd-grid-main">
                {/* COL IZQ */}
                <div className="cd-col">
                    <div className="cd-card">
                        <div className="cd-card-header">
                            <img src={iconTarjetas} /> Tarjetas
                        </div>
                        <div className="cd-card-body">
                            <div className="cd-grid-3">
                                {formasPago.some((item) => item === 1) && (
                                    <div className="cd-input-group"><label className="cd-label">AMEX</label><NumericFormat name="amex" value={formData.amex} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} prefix={"$"} onValueChange={(values) => handleValueChange(values, "amex")} className={`cd-input ${errors.amex ? "cd-input-error" : ""}`} required />{errors && <div className="cd-error-msg">{errors.amex}</div>}</div>
                                )}
                                {formasPago.some((item) => item === 2) && (
                                    <div className="cd-input-group"><label className="cd-label">TPV</label><NumericFormat name="tpv" value={formData.tpv} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} prefix={"$"} onValueChange={(values) => handleValueChange(values, "tpv")} className={`cd-input ${errors.tpv ? "cd-input-error" : ""}`} required />{errors && <div className="cd-error-msg">{errors.tpv}</div>}</div>
                                )}
                                {formasPago.some((item) => item === 3) && (
                                    <div className="cd-input-group"><label className="cd-label">PIN PAD</label><NumericFormat name="pinpad" value={formData.pinpad} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} prefix={"$"} onValueChange={(values) => handleValueChange(values, "pinpad")} className={`cd-input ${errors.pinpad ? "cd-input-error" : ""}`} required />{errors && <div className="cd-error-msg">{errors.pinpad}</div>}</div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="cd-card">
                        <div className="cd-card-header">
                            <img src={iconAgregaores} alt="" /> Agregadores
                        </div>
                        <div className="cd-card-body">
                            <div className="cd-grid-2">
                                {formasPago.some((item) => item === 6) && (
                                    <div className="cd-input-group"><label className="cd-label">Delivery Alsea</label><NumericFormat name="delivery" value={formData.delivery} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} prefix={"$"} onValueChange={(values) => handleValueChange(values, "delivery")} className={`cd-input ${errors.delivery ? "cd-input-error" : ""}`} required />{errors && <div className="cd-error-msg">{errors.delivery}</div>}</div>
                                )}
                                {formasPago.some((item) => item === 7) && (
                                    <div className="cd-input-group"><label className="cd-label">DIDI</label><NumericFormat name="didi" value={formData.didi} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} prefix={"$"} onValueChange={(values) => handleValueChange(values, "didi")} className={`cd-input ${errors.didi ? "cd-input-error" : ""}`} required />{errors && <div className="cd-error-msg">{errors.didi}</div>}</div>
                                )}
                                {formasPago.some((item) => item === 8) && (
                                    <div className="cd-input-group"><label className="cd-label">DIDI Creditos</label><NumericFormat name="didicredito" value={formData.didicredito} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} prefix={"$"} onValueChange={(values) => handleValueChange(values, "didicredito")} className={`cd-input ${errors.didicredito ? "cd-input-error" : ""}`} required />{errors && <div className="cd-error-msg">{errors.didicredito}</div>}</div>
                                )}
                                {formasPago.some((item) => item === 24) && (
                                    <div className="cd-input-group"><label className="cd-label">DIDI Efectivo</label><NumericFormat name="didiEfectivo" value={formData.didiEfectivo} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} prefix={"$"} onValueChange={(values) => handleValueChange(values, "didiEfectivo")} className={`cd-input ${errors.didiEfectivo ? "cd-input-error" : ""}`} required />{errors && <div className="cd-error-msg">{errors.didiEfectivo}</div>}</div>
                                )}
                                {formasPago.some((item) => item === 9) && (
                                    <div className="cd-input-group"><label className="cd-label">RAPPI</label><NumericFormat name="rappi" value={formData.rappi} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} prefix={"$"} onValueChange={(values) => handleValueChange(values, "rappi")} className={`cd-input ${errors.rappi ? "cd-input-error" : ""}`} required />{errors && <div className="cd-error-msg">{errors.rappi}</div>}</div>
                                )}
                                {formasPago.some((item) => item === 10) && (
                                    <div className="cd-input-group"><label className="cd-label">RAPPI Cargo</label><NumericFormat name="rapicargo" value={formData.rapicargo} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} prefix={"$"} onValueChange={(values) => handleValueChange(values, "rapicargo")} className={`cd-input ${errors.rapicargo ? "cd-input-error" : ""}`} required />{errors && <div className="cd-error-msg">{errors.rapicargo}</div>}</div>
                                )}
                                {formasPago.some((item) => item === 26) && (
                                    <div className="cd-input-group"><label className="cd-label">RAPPI Efectivo</label><NumericFormat name="rappiEfectivo" value={formData.rappiEfectivo} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} prefix={"$"} onValueChange={(values) => handleValueChange(values, "rappiEfectivo")} className={`cd-input ${errors.rappiEfectivo ? "cd-input-error" : ""}`} required />{errors && <div className="cd-error-msg">{errors.rappiEfectivo}</div>}</div>
                                )}
                                {formasPago.some((item) => item === 11) && (
                                    <div className="cd-input-group"><label className="cd-label">UBER</label><NumericFormat name="uber" value={formData.uber} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} prefix={"$"} onValueChange={(values) => handleValueChange(values, "uber")} className={`cd-input ${errors.uber ? "cd-input-error" : ""}`} required />{errors && <div className="cd-error-msg">{errors.uber}</div>}</div>
                                )}
                                {formasPago.some((item) => item === 12) && (
                                    <div className="cd-input-group"><label className="cd-label">UBER Direct</label><NumericFormat name="uberdirect" value={formData.uberdirect} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} prefix={"$"} onValueChange={(values) => handleValueChange(values, "uberdirect")} className={`cd-input ${errors.uberdirect ? "cd-input-error" : ""}`} required />{errors && <div className="cd-error-msg">{errors.uberdirect}</div>}</div>
                                )}
                                {formasPago.some((item) => item === 25) && (
                                    <div className="cd-input-group"><label className="cd-label">UBER Efectivo</label><NumericFormat name="uberEfectivo" value={formData.uberEfectivo} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} prefix={"$"} onValueChange={(values) => handleValueChange(values, "uberEfectivo")} className={`cd-input ${errors.uberEfectivo ? "cd-input-error" : ""}`} required />{errors && <div className="cd-error-msg">{errors.uberEfectivo}</div>}</div>
                                )}
                                {formasPago.some((item) => item === 29) && (
                                    <div className="cd-input-group"><label className="cd-label">Delivery Sr</label><NumericFormat name="deliverySr" value={formData.deliverySr} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} prefix={"$"} onValueChange={(values) => handleValueChange(values, "deliverySr")} className={`cd-input ${errors.deliverySr ? "cd-input-error" : ""}`} required />{errors && <div className="cd-error-msg">{errors.deliverySr}</div>}</div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                {/* COL DER */}
                <div className="cd-col">
                    <div className="cd-card">
                        <div className="cd-card-header">
                            <img src={iconValesFisicos} alt="" /> Vales físicos
                        </div>
                        <div className="cd-card-body">
                            <div className="cd-grid-2">
                                {formasPago.some((item) => item === 4) && (
                                    <div className="cd-input-group"><label className="cd-label">Vales</label><NumericFormat name="vales" value={formData.vales} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} prefix={"$"} onValueChange={(values) => handleValueChange(values, "vales")} className={`cd-input ${errors.vales ? "cd-input-error" : ""}`} required />{errors && <div className="cd-error-msg">{errors.vales}</div>}</div>
                                )}
                                {formasPago.some((item) => item === 5) && (
                                    <div className="cd-input-group"><label className="cd-label">Vales CDMX</label><NumericFormat name="valescdmx" value={formData.valescdmx} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} prefix={"$"} onValueChange={(values) => handleValueChange(values, "valescdmx")} className={`cd-input ${errors.valescdmx ? "cd-input-error" : ""}`} required />{errors && <div className="cd-error-msg">{errors.valescdmx}</div>}</div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="cd-card">
                        <div className="cd-card-header">
                            <img src={iconOtros} alt="" />Otros
                        </div>
                        <div className="cd-card-body">
                            <div className="cd-grid-3">
                                {formasPago.some((item) => item === 13) && (
                                    <div className="cd-input-group"><label className="cd-label">Mercado Pago</label><NumericFormat name="mercadopago" value={formData.mercadopago} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} prefix={"$"} onValueChange={(values) => handleValueChange(values, "mercadopago")} className={`cd-input ${errors.mercadopago ? "cd-input-error" : ""}`} required />{errors && <div className="cd-error-msg">{errors.mercadopago}</div>}</div>
                                )}
                                {formasPago.some((item) => item === 14) && (
                                    <div className="cd-input-group"><label className="cd-label">WOW</label><NumericFormat name="wow" value={formData.wow} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} prefix={"$"} onValueChange={(values) => handleValueChange(values, "wow")} className={`cd-input ${errors.wow ? "cd-input-error" : ""}`} required />{errors && <div className="cd-error-msg">{errors.wow}</div>}</div>
                                )}
                                {formasPago.some((item) => item === 15) && (
                                    <div className="cd-input-group"><label className="cd-label">MOP</label><NumericFormat name="mop" value={formData.mop} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} prefix={"$"} onValueChange={(values) => handleValueChange(values, "mop")} className={`cd-input ${errors.mop ? "cd-input-error" : ""}`} required />{errors && <div className="cd-error-msg">{errors.mop}</div>}</div>
                                )}
                                {formasPago.some((item) => item === 16) && (
                                    <div className="cd-input-group" style={{ gridColumn: 'span 2' }}><label className="cd-label">Starbucks Rewards</label><NumericFormat name="startbuckRegords" value={formData.startbuckRegords} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} prefix={"$"} onValueChange={(values) => handleValueChange(values, "startbuckRegords")} className={`cd-input ${errors.startbuckRegords ? "cd-input-error" : ""}`} required />{errors && <div className="cd-error-msg">{errors.startbuckRegords}</div>}</div>
                                )}
                                {formasPago.some((item) => item === 17) && (
                                    <div className="cd-input-group"><label className="cd-label">Scan & Pay</label><NumericFormat name="scanpay" value={formData.scanpay} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} prefix={"$"} onValueChange={(values) => handleValueChange(values, "scanpay")} className={`cd-input ${errors.scanpay ? "cd-input-error" : ""}`} required />{errors && <div className="cd-error-msg">{errors.scanpay}</div>}</div>
                                )}
                                {formasPago.some((item) => item === 18) && (
                                    <div className="cd-input-group"><label className="cd-label">BK App</label><NumericFormat name="bkapp" value={formData.bkapp} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} prefix={"$"} onValueChange={(values) => handleValueChange(values, "bkapp")} className={`cd-input ${errors.bkapp ? "cd-input-error" : ""}`} required />{errors && <div className="cd-error-msg">{errors.bkapp}</div>}</div>
                                )}
                                {formasPago.some((item) => item === 19) && (
                                    <div className="cd-input-group"><label className="cd-label">Eventos Walmart</label><NumericFormat name="eventosWalmart" value={formData.eventosWalmart} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} prefix={"$"} onValueChange={(values) => handleValueChange(values, "eventosWalmart")} className={`cd-input ${errors.eventosWalmart ? "cd-input-error" : ""}`} required />{errors && <div className="cd-error-msg">{errors.eventosWalmart}</div>}</div>
                                )}
                                {formasPago.some((item) => item === 20) && (
                                    <div className="cd-input-group"><label className="cd-label">Eventos Empresariales</label><NumericFormat name="eventosEmpresariales" value={formData.eventosEmpresariales} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} prefix={"$"} onValueChange={(values) => handleValueChange(values, "eventosEmpresariales")} className={`cd-input ${errors.eventosEmpresariales ? "cd-input-error" : ""}`} required />{errors && <div className="cd-error-msg">{errors.eventosEmpresariales}</div>}</div>
                                )}
                                {formasPago.some((item) => item === 27) && (
                                    <div className="cd-input-group"><label className="cd-label">Anticipo/Otros Cred.</label><NumericFormat name="anticipoOtrosCreditos" value={formData.anticipoOtrosCreditos} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} prefix={"$"} onValueChange={(values) => handleValueChange(values, "anticipoOtrosCreditos")} className={`cd-input ${errors.anticipoOtrosCreditos ? "cd-input-error" : ""}`} required />{errors && <div className="cd-error-msg">{errors.anticipoOtrosCreditos}</div>}</div>
                                )}
                                {formasPago.some((item) => item === 28) && (
                                    <div className="cd-input-group"><label className="cd-label">Otros Creditos</label><NumericFormat name="otrosCreditos" value={formData.otrosCreditos} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} prefix={"$"} onValueChange={(values) => handleValueChange(values, "otrosCreditos")} className={`cd-input ${errors.otrosCreditos ? "cd-input-error" : ""}`} required />{errors && <div className="cd-error-msg">{errors.otrosCreditos}</div>}</div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="cd-card">
                        <div className="cd-card-header">
                            <img src={iconEfectivo} alt="" /> Efectivo
                        </div>
                        <div className="cd-card-body">
                            <div className="cd-grid-2">
                                {formasPago.some((item) => item === 21) && (
                                    <div className="cd-input-group"><label className="cd-label">Efectivo MXP</label><NumericFormat name="efectivomxp" value={formData.efectivomxp} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} prefix={"$"} onValueChange={(values) => handleValueChange(values, "efectivomxp")} className={`cd-input ${errors.efectivomxp ? "cd-input-error" : ""}`} required />{errors && <div className="cd-error-msg">{errors.efectivomxp}</div>}</div>
                                )}
                                {formasPago.some((item) => item === 22) && (
                                    <div className="cd-input-group"><label className="cd-label">Efectivo USD</label><NumericFormat name="efectivousd" value={formData.efectivousd} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} prefix={"$"} onValueChange={(values) => handleValueChange(values, "efectivousd")} className={`cd-input ${errors.efectivousd ? "cd-input-error" : ""}`} required />{errors && <div className="cd-error-msg">{errors.efectivousd}</div>}</div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* --- 3. BANNER TOTAL --- */}
            <div className="cd-banner-total">
                <div>Total formas de pago:</div>
                <div className="cd-banner-amount"><NumericFormat value={suma} displayType={'text'} thousandSeparator={true} prefix={'$ '} decimalScale={2} fixedDecimalScale={true} /></div>
            </div>

            {/* --- 4. DEPÓSITOS --- */}
            <div className="cd-card">
                <div className="cd-card-header">
                    <img src={iconDepositosEfectivo} alt="" />
                    Depositos en efectivo
                </div>
                <div className="cd-creclard-body p-4">
                    <div className="cd-grid-3">
                        {formasPago.some((item) => item === 23) && (
                            <>
                                <div className="cd-input-group"><label className="cd-label">% PROPINA</label><NumericFormat name="propinpor" value={formDataNoSuma.propinpor} decimalScale={2} onValueChange={(values) => handleChangeNoSuma(values, "propinpor")} className="cd-input" required /></div>
                                <div className="cd-input-group"><label className="cd-label">$ PROPINA</label><NumericFormat name="propina" value={propina} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} prefix={"$"} className="cd-input" required /></div>
                            </>
                        )}
                        <div className="cd-input-group"><label className="cd-label">DEPOSITOS EN TOMBOLA</label><NumericFormat name="depostitoTombola" value={formDataNoSuma.depostitoTombola} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} prefix={"$"} onValueChange={(values) => handleChangeNoSuma(values, "depostitoTombola")} className={`cd-input ${errors.depostitoTombola ? "cd-input-error" : ""}`} required />{errors && <div className="cd-error-msg">{errors.depostitoTombola}</div>}</div>
                        <div className="cd-input-group"><label className="cd-label">EFECTIVO A DEPOSITAR</label><NumericFormat name="efectivoDepositar" value={efectivoDepositar} thousandSeparator={true} decimalScale={2} fixedDecimalScale={true} prefix={"$"} className={`cd-input ${errors.efectivoDepositar ? "cd-input-error" : ""}`} required />{errors && <div className="cd-error-msg">{errors.efectivoDepositar}</div>}</div>
                    </div>
                    <div>
                        <label className="cd-label">Comentarios</label>
                        <textarea value={comentario} onChange={handleChangeComentario} placeholder="Escribe aquí tu comentario" rows={3} maxLength={300} className={`cd-textarea ${comentario.length >= 300 ? "cd-input-error" : ""}`} />
                        {comentario.length >= 300 && <div className="cd-error-msg">Máximo 300 caracteres</div>}
                    </div>
                </div>
            </div>

            {/* --- 5. FOOTER & EVIDENCIAS --- */}

            {/* IZQUIERDA: Botones de Evidencia */}
            <div className="row">
                <div className="col-sm-12 col-md-6">

                    <div className="row align-items-start">
                        <div className="col-4 col-buttons">
                            <button className="cd-btn-evidence" onClick={() => setModalVisible(true)}>
                                <img src={imgCierre} alt="icon" style={{ width: '24px', filter: 'brightness(0) invert(1)' }} /><span>Cierre de Lote-Pinpad</span>
                            </button>
                            <div className="cd-preview-box">
                                {isShowImage ? <LoadingSpinner /> : (imageURL && <Image src={image} alt="PinPad" className="cd-img-thumb" />)}
                                {errors && <div className="cd-error-msg">{errors.imageURL}</div>}
                            </div>
                        </div>
                        <div className="col-4 col-buttons">
                            <button className="cd-btn-evidence" onClick={() => setModalVisibleFicha(true)}>
                                <img src={iconFichaDeposito} alt="icon" style={{ width: '24px', filter: 'brightness(0) invert(1)' }} /><span>Ficha Depósito</span>
                            </button>
                            <div className="cd-preview-box">
                                {isShowImageDep ? <LoadingSpinner /> : (imageDepositoURL && <Image src={imageDeposito} alt="Deposito" className="cd-img-thumb" />)}
                                {errors && <div className="cd-error-msg">{errors.imageDepositoURL}</div>}
                            </div>
                        </div>
                        <div className="col-4 col-buttons">
                            <button className="cd-btn-evidence" onClick={() => setModalVisibleValores(true)}>
                                <img src={imgEntrega} alt="icon" style={{ width: '24px', filter: 'brightness(0) invert(1)' }} /><span>Entrega Valores</span>
                            </button>
                            <div className="cd-preview-box">
                                {isShowImageVal ? <LoadingSpinner /> : (imageValoresURL && <Image src={imageValores} alt="Valores" className="cd-img-thumb" />)}
                                {errors && <div className="cd-error-msg">{errors.imageValoresURL}</div>}
                            </div>
                        </div>
                        <div className="col-4 col-buttons">
                            {shouldShowCofreElectronico && (
                                <button className="cd-btn-evidence" onClick={() => setModalVisibleCofreElectronico(true)}>
                                    <img src={iconoCofreElectronico} alt="icon" style={{ width: '24px', filter: 'brightness(0) invert(1)' }} /><span>Cofre Electrónico</span>
                                </button>
                            )}
                            {shouldShowCofreElectronico && (
                                <div className="cd-preview-box">
                                    {isShowImageCofreElectronico ? <LoadingSpinner /> : (imageCofreElectronicoURL && <Image src={imageCofreElectronico} alt="Cofre" className="cd-img-thumb" />)}
                                    {errors && <div className="cd-error-msg">{errors.imageCofreElectronicoURL}</div>}
                                </div>
                            )}
                        </div>
                        <div className="col-4 col-buttons">
                            <button className="cd-btn-evidence" onClick={() => setModalVisibleReporteVentas(true)}>
                                <img src={iconoReporteVentas} alt="icon" style={{ width: '24px', filter: 'brightness(0) invert(1)' }} /><span>Reporte Ventas</span>
                            </button>
                            <div className="cd-preview-box">
                                {isShowImageReporteVentas ? <LoadingSpinner /> : (imageReporteVentasURL && <Image src={imageReporteVentas} alt="Reporte" className="cd-img-thumb" />)}
                                {errors && <div className="cd-error-msg">{errors.imageReporteVentasURL}</div>}
                            </div>
                        </div>
                    </div>

                    {/* PREVISUALIZACIÓN IMÁGENES */}
                    {/*<div className="cd-evidence-row" style={{marginTop:'15px', flexWrap:'wrap'}}>*/}
                    {/*    /!* 1. Cierre PinPad *!/*/}
                    {/*    <div className="cd-preview-box">*/}
                    {/*        {isShowImage ? <LoadingSpinner /> : (imageURL && <Image width={80} src={image} alt="PinPad" className="cd-img-thumb"/>)}*/}
                    {/*        {errors && <div className="cd-error-msg">{errors.imageURL}</div>}*/}
                    {/*    </div>*/}
                    {/*    /!* 2. Depósito *!/*/}
                    {/*    <div className="cd-preview-box">*/}
                    {/*        {isShowImageDep ? <LoadingSpinner /> : (imageDepositoURL && <Image width={80} src={imageDeposito} alt="Deposito" className="cd-img-thumb"/>)}*/}
                    {/*        {errors && <div className="cd-error-msg">{errors.imageDepositoURL}</div>}*/}
                    {/*    </div>*/}
                    {/*    /!* 3. Valores *!/*/}
                    {/*    <div className="cd-preview-box">*/}
                    {/*        {isShowImageVal ? <LoadingSpinner /> : (imageValoresURL && <Image width={80} src={imageValores} alt="Valores" className="cd-img-thumb"/>)}*/}
                    {/*        {errors && <div className="cd-error-msg">{errors.imageValoresURL}</div>}*/}
                    {/*    </div>*/}
                    {/*    /!* 4. Cofre Electronico (Aquí estaba el error de faltar el div) *!/*/}
                    {/*    {shouldShowCofreElectronico && (*/}
                    {/*        <div className="cd-preview-box">*/}
                    {/*            {isShowImageCofreElectronico ? <LoadingSpinner /> : (imageCofreElectronicoURL && <Image width={80} src={imageCofreElectronico} alt="Cofre" className="cd-img-thumb"/>)}*/}
                    {/*            {errors && <div className="cd-error-msg">{errors.imageCofreElectronicoURL}</div>}*/}
                    {/*        </div>*/}
                    {/*    )}*/}
                    {/*    /!* 5. Reporte Ventas *!/*/}
                    {/*    <div className="cd-preview-box">*/}
                    {/*        {isShowImageReporteVentas ? <LoadingSpinner /> : (imageReporteVentasURL && <Image width={80} src={imageReporteVentas} alt="Reporte" className="cd-img-thumb"/>)}*/}
                    {/*        {errors && <div className="cd-error-msg">{errors.imageReporteVentasURL}</div>}*/}
                    {/*    </div>*/}
                    {/*</div>*/}

                </div>
                <div className="col-sm-12 col-md-6">
                    {/* DERECHA: Datos finales */}
                    <div className="cd-save-area">
                        <div>
                            <label className="cd-label">Nombre del Gerente</label>
                            <input type="text" name="nombre" value={nombre} onChange={handleChangeNombre} placeholder="Nombre del Gerente en turno" className="cd-input" required />
                            {errors && <div className="cd-error-msg">{errors.nombre}</div>}
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
                            {AllNull && (
                                <button onClick={setSaveReclasificacionCloseStores} className="cd-btn-close-store">Tienda Cerrada</button>
                            )}
                            <button onClick={setSaveReclasificacion} className="cd-btn-save">Guardar</button>
                        </div>
                    </div>
                </div>

            </div>

            {/* --- MODALES (Lógica intacta) --- */}
            <Modal open={modalVisible} onCancel={() => setModalVisible(false)} footer={null}>
                <div className="conteiner-modal-body-evidencias">
                    <div>
                        {image == null && (
                            <>
                                <div style={{ marginBottom: '10px' }}>La imagen seleccionada debe estar en formato JPG y tener un tamaño inferior a 1 MB</div>
                                <label htmlFor="image-input" style={{ background: "#c2185b", color: "#fff", padding: "10px 15px", borderRadius: "5px", cursor: "pointer" }}>Seleccionar Imagen</label>
                                <input type="file" id="image-input" onChange={handleImageChangeFicha} accept=".jpg, .jpeg" capture="user" style={{ display: "none" }} />
                            </>
                        )}
                        {image && (
                            <>
                                <div><img src={image} alt="Selected Image" className="image-pick-recolecion" style={{ width: '100%', marginBottom: '10px' }} /></div>
                                <div className="d-flex justify-content-center gap-3">
                                    <div className="file-select" id="src-file1">
                                        <input type="file" accept=".jpg, .jpeg" onChange={handleImageChangeFicha} className="input-content-img" capture="user" />
                                    </div>
                                    <button className="file-button-save" onClick={saveImage} style={{ background: "#c2185b", color: "#fff", padding: "10px", border: 'none', borderRadius: "5px" }}>Guardar</button>

                                </div>
                            </>
                        )}
                    </div>
                </div>
            </Modal>

            <Modal open={modalVisibleFicha} onCancel={() => setModalVisibleFicha(false)} footer={null}>
                <div className="conteiner-modal-body-evidencias">
                    <div>
                        {imageDeposito == null && (
                            <>
                                <div style={{ marginBottom: '10px' }}>La imagen seleccionada debe estar en formato JPG y tener un tamaño inferior a 1 MB</div>
                                <label htmlFor="image-inputDeposito" style={{ background: "#c2185b", color: "#fff", padding: "10px 15px", borderRadius: "5px", cursor: "pointer" }}>Seleccionar Imagen</label>
                                <input type="file" onChange={handleImageChangeDeposito} accept=".jpg, .jpeg" capture="user" id="image-inputDeposito" style={{ display: "none" }} />
                            </>
                        )}
                        {imageDeposito && (
                            <>
                                <div><img src={imageDeposito} alt="Selected Image" className="image-pick-recolecion" style={{ width: '100%', marginBottom: '10px' }} /></div>
                                <div className="d-flex justify-content-center gap-3">
                                    <div className="file-select" id="src-file1"><input type="file" accept=".jpg, .jpeg" capture="user" onChange={handleImageChangeDeposito} className="input-content-img" /></div>
                                    <button className="file-button-save" onClick={saveImageDeposito} style={{ background: "#c2185b", color: "#fff", padding: "10px", border: 'none', borderRadius: "5px" }}>Guardar</button>
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </Modal>

            {/* Componentes de Modal Externos (Lógica Original) */}
            {shouldShowCofreElectronico && (
                <ModalCofreElectronico open={modalVisibleCofreElectronico} setOpen={setModalVisibleCofreElectronico} image={imageCofreElectronico} saveImage={saveImageCofreElectronico} handleImageChange={handleImageChangeCofreElectronico} />
            )}
            <ModalReporteVentas open={modalVisibleReporteVentas} setOpen={setModalVisibleReporteVentas} image={imageReporteVentas} saveImage={saveImageReporteVentas} handleImageChange={handleImageChangeReporteVentas} />

            <Modal open={modalVisibleValores} onCancel={() => setModalVisibleValores(false)} footer={null}>
                <div className="conteiner-modal-body-evidencias">
                    <label><Switch onChange={handleChangCheck} checked={checked} className="react-switch" /></label>
                    <div>
                        {checked ? (
                            <div>
                                <div className="text-top-image-modal">No recoleción de valores</div>
                                <div className="center-selecionar-image-valores">
                                    <div className="text-top-image-modal">Coloca # ticket de Mesa de Servicio</div>
                                    <input type="text" name="ticket" onChange={handleChangeTicket} value={noTicket} className="cd-input" required style={{ marginBottom: '10px' }} />
                                    <button onClick={() => setModalVisibleValores(false)} style={{ background: "#c2185b", color: "#fff", padding: "10px", border: 'none', borderRadius: "5px" }}>Guardar</button>
                                </div>
                            </div>
                        ) : (
                            <div>
                                {imageValores == null && (
                                    <>
                                        <div style={{ marginBottom: '10px' }}>La imagen debe ser JPG y menor a 1 MB</div>
                                        <label htmlFor="image-inputValores" style={{ background: "#c2185b", color: "#fff", padding: "10px 15px", borderRadius: "5px", cursor: "pointer" }}>Seleccionar Imagen</label>
                                        <input type="file" onChange={handleImageChangeValores} accept=".jpg, .jpeg" capture="user" id="image-inputValores" style={{ display: "none" }} />
                                    </>
                                )}
                                {imageValores && (
                                    <>
                                        <div><img src={imageValores} alt="Selected Image" className="image-pick-recolecion" style={{ width: '100%', marginBottom: '10px' }} /></div>
                                        <div className="d-flex justify-content-center gap-3">
                                            <div className="file-select" id="src-file1"><input type="file" accept=".jpg, .jpeg" capture="user" onChange={handleImageChangeValores} className="input-content-img" /></div>
                                            <button className="file-button-save" onClick={saveImageValores} style={{ background: "#c2185b", color: "#fff", padding: "10px", border: 'none', borderRadius: "5px" }}>Guardar</button>
                                        </div>
                                    </>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </Modal>
        </div>
    );
};